import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

/** Checkboxes stand in for a signature: this provider binds on accepted terms, with no e-sign. */
export function AcceptTermsStep({ id, onAccept }: { id: string; onAccept: () => void }) {
  const [checked, setChecked] = useState<ReadonlySet<number>>(new Set())
  // Locked once accepted: the card has already counted the step done, so unticking can't undo it.
  const [isAccepted, setIsAccepted] = useState(false)

  // Placeholder until Corgi's bind terms are available to the prototype.
  const terms = [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
    'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.',
  ]

  function toggle(index: number, isChecked: boolean) {
    setChecked((current) => {
      const next = new Set(current)
      if (isChecked) next.add(index)
      else next.delete(index)
      return next
    })
  }

  return (
    <div className="mt-3 flex flex-col items-start gap-4 lg:max-w-[400px]">
      <ul className="flex flex-col gap-3">
        {terms.map((term, index) => (
          <li key={index} className="flex items-start gap-3">
            <Checkbox
              id={`${id}-${index}`}
              checked={checked.has(index)}
              disabled={isAccepted}
              onCheckedChange={(isChecked) => toggle(index, !!isChecked)}
              className="mt-0.5"
            />
            <Label htmlFor={`${id}-${index}`} className="block text-sm font-normal">
              {term}
            </Label>
          </li>
        ))}
      </ul>
      <Button
        disabled={isAccepted || checked.size < terms.length}
        onClick={() => {
          setIsAccepted(true)
          onAccept()
        }}
      >
        Accept and continue
      </Button>
    </div>
  )
}
